import { defineMessages } from "react-intl";

import EmailStatus from "@mapmycustomers/shared/enum/EmailStatus";

const statusMessages = defineMessages({
  [EmailStatus.CANCELLED]: {
    id: "emailQueueModal.status.cancelled",
    defaultMessage: "Cancelled",
    description: "Email queue modal action cancelled status name.",
  },
  [EmailStatus.ERRORED]: {
    id: "emailQueueModal.status.errored",
    defaultMessage: "Not Sent",
    description: "Email queue modal action errored status name.",
  },
  [EmailStatus.SCHEDULED]: {
    id: "emailQueueModal.status.scheduled",
    defaultMessage: "Scheduled",
    description: "Email queue modal action scheduled status name.",
  },
  [EmailStatus.SENDING]: {
    id: "emailQueueModal.status.sending",
    defaultMessage: "Sending",
    description: "Email queue modal action sending status name.",
  },
  [EmailStatus.SENT]: {
    id: "emailQueueModal.status.sent",
    defaultMessage: "Sent",
    description: "Email queue modal action sent status name.",
  },
  [EmailStatus.SUBMITTED]: {
    id: "emailQueueModal.status.submitted",
    defaultMessage: "Queued",
    description: "Email queue modal action submitted status name.",
  },
});

export default statusMessages;
